import React, { Component } from 'react';
import styled from 'styled-components';
import { Trail } from 'react-spring';
import { Tap } from '../dooh-react-utils';
import preloader from '../preload';
import { icons } from '../preload';

const Wrap = styled.div`
  background: url('${() =>
    preloader.get(require('../assets/bg.jpg'))}') no-repeat 0 0;
  color: white;
  padding-top: 90px;
`;

const Answers = styled.div`
  font-size: 40px;
  position: absolute;
  top: 700px;
  left: 160px;
  width: 720px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-around;
`;

const Answer = styled(Tap)`
  font-family: RegularFont;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1.3;
  width: 300px;
  height: 250px;
  box-sizing: border-box;
  margin: 0 auto;
  color: white;
  text-align: center;
  font-size: 60px;
  transition: background 0.3s ease-in-out;

  img {
    width: 200px;
    height: 200px;
  }

  span {
    display: block;
    width: 100px;
    white-space: nowrap;
    overflow: hidden;
  }

  img,
  span {
    transition: opacity 0.3s ease-in-out;
  }
`;

const Question = styled.div`
  line-height: 1.3;
  font-size: 70px;
  position: relative;
  top: 360px;
  left: 190px;
  width: 800px;

  b {
    font-family: BoldFont;
  }
`;

class Screen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      score: [0, 0, 0, 0],
      current: 0,
      time: +new Date(),
      selectedAnswer: null,
      phase: 'NOT_ANSWERED', // ANSWERED, TIMEOUT
    };
  }

  componentDidMount() {
    //this.setState(this.nextQuestion);
    this.nextQuestionTimeout = null;
  }

  render() {
    let { questions } = this.props;
    let { current } = this.state;
    let q = questions[current];
    return (
      <Wrap q={this.state.current}>
        <Question className={q.cls}>{q.question}</Question>

        <Answers>
          <Trail
            items={q.answers}
            keys={item => `${current}/${item.a}`}
            from={{ opacity: 0, transform: 'translate3d(0, -20px, 0)' }}
            to={{ opacity: 1, transform: 'translate3d(0, 0px, 0)' }}
          >
            {item => style => this.getAnswer(item, style)}
          </Trail>
        </Answers>
      </Wrap>
    );
  }

  getAnswer = (answer, style) => {
    let styl = {};

    if (
      this.state.phase === 'ANSWERED' &&
      answer.i !== this.state.selectedAnswer
    ) {
      styl['opacity'] = 0.3;
    } else {
      styl['opacity'] = 1;
    }

    return (
      <Answer
        className={answer.cls}
        key={`${this.state.current}/${answer.a}`}
        onTap={() => this.answer(answer)}
        preventDoubleTap={false}
        style={style}
      >
        <span style={styl}>{['a', 'b', 'c', 'd'][answer.i]})</span>
        <img
          style={styl}
          width={200}
          height={200}
          src={preloader.get(icons[answer.qi][answer.i])}
          alt=""
        />
      </Answer>
    );
  };

  answer = a => {
    if (this.state.phase !== 'NOT_ANSWERED') return;
    const dt = +new Date() - this.state.time;
    if (dt < 500) return;

    let score = [...this.state.score];
    score[a.a] += 1;

    this.setState(s => ({
      ...s,
      phase: 'ANSWERED',
      score,
      selectedAnswer: a.i,
    }));

    if (this.state.current === this.props.questions.length - 1) {
      setTimeout(this.nextScreen, 800);
    } else {
      this.nextQuestionTimeout = setTimeout(
        () => this.setState(this.nextQuestion),
        1000
      );
    }
  };

  nextQuestion = s => {
    return {
      ...s,
      current: s.current + 1,
      selectedAnswer: null,
      phase: 'NOT_ANSWERED',
      time: +new Date(),
    };
  };

  nextScreen = () => {
    this.setState({ phase: 'TIMEOUT' });

    this.props.update(s => ({
      ...s,
      score: this.state.score,
    }));

    this.props.gotoNextScreen();
  };
}

export default Screen;
